// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/runway-manoeuvre-clearances.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/runway-manoeuvre-clearances/runway-manoeuvre-clearances.js';

mount([g0]);
